import { type FC } from "react";
import { Table } from "semantic-ui-react";

import { type Group } from "../../../interfaces";
import dateTimeUtils from "../../../utils/dateTimeUtils";
import GroupInfoCell from "../../groupInfoCell/GroupInfoCell";
import { getGroupsColumnOptions } from "./getGroupsColumnOptions";

export interface IGroupsTableBody {
  group: Group;
}

const GroupsTableBody: FC<IGroupsTableBody> = ({ group }): React.ReactElement => {
  const columnOptions = getGroupsColumnOptions();
  return (
    <>
      <Table.Cell width={columnOptions[0].width}>
        <GroupInfoCell group={group} />
      </Table.Cell>
      <Table.Cell width={columnOptions[1].width}>{group.membersCount}</Table.Cell>
      <Table.Cell width={columnOptions[2].width}>{dateTimeUtils.formatDate(group.dateCreated)}</Table.Cell>
    </>
  );
};

export default GroupsTableBody;
